import { ContactCard, ContactPerson } from '../../contactCard/ContactCard'
import { AppearItem } from '../blocks/AppearInViewport'

export type ContactContentSectionType = {
  type: 'contactPanel'
  title: string
  body?: string
  listItems: ContactPerson[]
}

export const ContactContentSection = ({
  title,
  body,
  listItems,
}: ContactContentSectionType) => {
  if (listItems.length === 0) {
    return null
  }

  return (
    <AppearItem staggerIndex={0}>
      <ContactCard title={title} htmlContent={body} contactPeople={listItems} />
    </AppearItem>
  )
}
